import { useSearchParams } from "next/navigation";
import { CSSProperties, useEffect, useState } from "react";

import CheckBox from "@/components/CheckBox";
import Loader from "@/components/Loader";
import useFetch from "@/hooks/useFetch";
import { addQueryPrefix } from "@/hooks/useProductsFilter";
import { getCategoryListLayerCached } from "@/requests/category";
import { jsonParseSafe, toTwoDigit } from "@/utils";
import { Accordion } from "@mantine/core";
import Link from "next/link";
import classes from "./FilterItems.module.css";

const filterItemsStatic: FilterItemType[] = [
  {
    id: 11,
    label: "Storage",
    name: "storage",
    options: ["64GB", "128GB", "256GB", "512GB", "1TB", "2TB", "4TB"],
    type: "multiple",
  },
  {
    id: 12,
    label: "RAM",
    name: "ram",
    options: ["4GB", "8GB", "16GB", "32GB"],
    type: "multiple",
  },
  {
    id: 13,
    label: "Color",
    name: "color",
    options: ["Black", "White", "Red", "Green", "Blue"],
    type: "multiple",
  },
];

// const onlineProductsFilter: FilterItemType[] = [
//   {
//     id: 21,
//     label: "Online Exclusive",
//     name: "isOnline",
//     options:
//       '[{"valueId":1,"value":"Online Exclusive"},{"valueId":2,"value":"In Stock"},{"valueId":3,"value":"Out of Stock"}]',
//     type: "single",
//   },
// ];

interface Props {
  className?: string;
  style?: CSSProperties;
  type?: CategoryPageType;

  slug?: string;
  subcategories?: CategoryItem[];

  onFilter?: (key: string, value: string) => void;

  filterAttributes: ReturnType<typeof useFetch<CategoryFilters>>;
}

export const FilterItemsAccordion = ({
  className,
  style,
  type = "default",

  slug,
  subcategories,

  onFilter = () => {},

  filterAttributes,
}: Props) => {
  const searchParams = useSearchParams();
  // const [filterLabels, setFilterLabel] = useState<string[]>([]);

  const attr = filterAttributes.response?.filterGroup?.filter || [];
  const fileterLables = attr.map((a) => a.label);

  // useEffect(() => {
  //   setFilterLabel(attr.map((a) => a.label));
  // }, [attr]);

  // const attributes = filterAttributes.response?.filters || [];

  // const filterItems =
  //   attributes.length > 0
  //     ? attributes
  //     : type === "online"
  //     ? []
  //     : filterItemsStatic;

  const filterItemss =
    attr && attr.length > 0 ? attr : type === "online" ? [] : [];

  const classNames = [classes.FilterItems, className];

  return (
    <div className={classNames.join(" ")} style={style}>
      <Accordion
        key={fileterLables.length > 0 ? fileterLables.join(",") : "no-labels"}
        // classNames={{ chevron: classes.chevron }}
        multiple={true}
        defaultValue={type === "online" ? ["Subcategories"] : fileterLables}
        className={classes.accordion}

        // chevron={<PlusOutlineIcon className={classes.icon} />}
      >
        {!filterAttributes.loading &&
          attr?.map((filterItem, index) => {
            const queryValue = searchParams?.get(
              addQueryPrefix(filterItem.label)
            );

            const decodedQueryValue = decodeURIComponent(queryValue || "");

            const queryValues = queryValue ? decodedQueryValue.split(",") : [];

            return (
              <Accordion.Item
                key={filterItem.id + "_" + index + "-filter-item-" + filterItem.label}
                value={filterItem.label}
                className={classes.filterItem}
              >
                <Accordion.Control
                  className={classes.title}
                  styles={{
                    control: {
                      backgroundColor: "transparent",
                      textTransform: "uppercase",
                    },
                  }}
                >
                  {filterItem.label}
                </Accordion.Control>

                <Accordion.Panel>
                  <FilterItem
                    options={filterItem.options}
                    filter={filterItem}
                    type={filterItem.type}
                    className={classes.items}
                    activeValues={queryValues}
                    filterLabel={filterItem.label}
                    onFilter={(value: any) => {
                      let newValue = "";

                      const val = value.value;

                      if (queryValues.includes(val)) {
                        newValue = queryValues
                          .filter((v) => v !== val)
                          .join(",");
                      } else {
                        newValue = queryValues.concat(val).join(",");
                      }

                      onFilter(filterItem.label, encodeURIComponent(newValue));
                    }}
                  />
                </Accordion.Panel>
              </Accordion.Item>
            );
          })}

        {filterAttributes.loading && (
          <div className="flex justify-center py">
            <Loader size={26} />
          </div>
        )}
      </Accordion>
    </div>
  );
};

interface CateogryTreeProps extends Props {
  parentId?: number;
  item?: CategoryItem;
  title?: string;
  activeValues?: string[];
}

export const FilterItemsCategoryTree = ({
  className,
  style,
  title,

  activeValues = [],
  parentId,
  item,

  onFilter = () => {},
  filterAttributes,
}: CateogryTreeProps) => {
  const searchParams = useSearchParams();

  const categoryRes = useFetch(() => getCategoryListLayerCached({ parentId }), {
    deps: [parentId],
  });

  const filterItems = categoryRes.response || [];

  const classNames = [classes.FilterItems, classes.tree, className];

  return (
    <div className={classNames.join(" ")} style={style}>
      <Accordion
        // classNames={{ chevron: classes.chevron }}
        multiple={true}
        defaultValue={!parentId ? ["Category"] : []}
        className={classes.accordion}
        // chevron={<PlusOutlineIcon className={classes.icon} />}
      >
        {filterItems && filterItems.length > 0 && (
          <Accordion.Item value="Category" className={classes.filterItem}>
            {item && (
              <button className={`w-full flex gap-3 mb-1 cursor-pointer`}>
                <CheckBox
                  checked={activeValues.includes(item.slug)}
                  onClick={() => {
                    const value = item?.slug;

                    let newValue = "";

                    if (activeValues.includes(value)) {
                      newValue = activeValues
                        .filter((v) => v !== value)
                        .join(",");
                    } else {
                      newValue = activeValues.concat(value).join(",");
                    }

                    onFilter("category", newValue);
                  }}
                />

                <Accordion.Control
                  className={classes.title + " flex-1"}
                  styles={{
                    control: {
                      backgroundColor: "transparent",
                      padding: "0",
                      margin: "0",
                    },
                    label: {
                      padding: "0",
                      fontSize: "0.875rem",
                    },
                  }}
                >
                  {title || "Category"}
                </Accordion.Control>
              </button>
            )}

            <Accordion.Panel>
              {filterItems.map((item) => {
                if (item.slug === "/") return null;

                const activeValues =
                  searchParams?.get(addQueryPrefix("category"))?.split(",") ||
                  [];

                const active = activeValues.includes(item.slug);

                if (!item.leaf) {
                  return (
                    <FilterItemsCategoryTree
                      key={item.id + "-category-tree-" + item.slug}
                      title={item.name}
                      filterAttributes={filterAttributes}
                      parentId={item.id}
                      activeValues={activeValues}
                      item={item}
                      onFilter={onFilter}
                    />
                  );
                }

                return (
                  <button
                    key={'filter-item-'+item.slug}
                    className={`flex gap-3 mb-1 cursor-pointer`}
                    onClick={() => {
                      const value = item.slug;

                      let newValue = "";

                      if (activeValues.includes(value)) {
                        newValue = activeValues
                          .filter((v) => v !== value)
                          .join(",");
                      } else {
                        newValue = activeValues.concat(value).join(",");
                      }

                      onFilter("category", newValue);
                    }}
                  >
                    <CheckBox checked={active} />

                    <p className={classes.text + " !text-sm"}>{item.name}</p>
                  </button>
                );
              })}
            </Accordion.Panel>
          </Accordion.Item>
        )}

        {categoryRes.loading && (
          <div className="flex justify-center py">
            <Loader size={26} />
          </div>
        )}
      </Accordion>
    </div>
  );
};

const MAX_ITEMS = 4;

export const FilterItem = ({
  options,
  filter,
  type,
  className,
  isLink = false,
  noLimit = false,
  filterLabel = "",

  onFilter = () => {},
  getLabel,
  activeValues,
}: {
  options: string;
  filter: Filter;
  type: string;
  className?: string;
  isLink?: boolean;
  noLimit?: boolean;
  filterLabel?: string;

  onFilter?: (value: string) => void;
  getLabel?: (value: string) => string;
  activeValues: string[];
}) => {
  const [expanded, setExpanded] = useState(noLimit);
  const [maxItems, setMaxItems] = useState(MAX_ITEMS + (isLink ? 3 : 0));

  const stringifyJson = JSON.stringify(options);

  const items = jsonParseSafe(stringifyJson);

  return (
    <div className={className}>
      {items.map((item: any, index: number) => {
        // if (index > maxItems && !expanded) return null;

        // Handle both object items with .value property and plain string items
        const value = typeof item === 'string' ? item : item.value;

        if (!value) return null;

        const active = activeValues.includes(value);
        // Ensure truly unique keys by combining all identifying information
        // Include filterIdentifier + value + index for global uniqueness across all filters
        const filterIdentifier = filter?.id || filter?.name || filterLabel || 'unknown';
        const uniqueKey = `${filterIdentifier}_${value}_${index}`;

        if (isLink)
          return (
            <Link
              key={uniqueKey + "-filter-item-link"}
              href={`/category/${item}`}
              className={classes.item + " hover:underline"}
            >
              <p className={classes.text}>{getLabel ? getLabel(item) : item}</p>
            </Link>
          );

        return (
          <button
            key={uniqueKey + "-filter-item-button"}
            className={`flex gap-3 mb-1 cursor-pointer`}
            onClick={() => {
              // Handle both string and object items
              const itemToPass = typeof item === 'string' ? { value: item } : item;
              onFilter(itemToPass);
            }}
          >
            <CheckBox checked={active} />

            {/* <p className={classes.text}>{getLabel ? getLabel(item) : item}</p> */}
            <p className={classes.text}>{value}</p>
          </button>
        );
      })}

      {/* {expanded && !noLimit && (
        <div
          key="unique"
          className={classes.item}
          onClick={() => setMaxItems(MAX_ITEMS)}
        >
          <p className={classes.moreText}>- Show less</p>
        </div>
      )} */}
    </div>
  );
};

// export default FilterItems;
